import { db } from '../../db';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { Property } from '@/models/Property';
import { chunkArray } from './utils';
import { getCollectionPage } from './getCollectionPage';

export class FirestorePropertyRepository {
  async fetchAddresses(cityId, addressIds) {
    const firestore = await db;
    const chunks = chunkArray(addressIds, 10);
    const snapshots = await Promise.all(chunks.map(ids => {
      return getDocs(query(
        collection(firestore, 'cities', cityId, 'addresses'),
        where('id', 'in', ids)
      ));
    }));
    const docs = [];
    snapshots.forEach(snapshot => {
      snapshot.docs.forEach(docSnap => docs.push(docSnap));
    });
    return docs;
  }

  async propertiesSearch(city, options = {}) {
    return getCollectionPage(
      `cities/${city.id}/properties`,
      docSnap => new Property(city, docSnap),
      options
    );
  }
}
